// components/BpCardsSection.jsx
import React from "react";
import { useTranslation, Trans } from "react-i18next";

/* SVG-иконки из прототипа (JSX-совместимые) */
const IconProcesses = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.7">
    <path d="M6 3h4v4H6zM14 17h4v4h-4zM14 3h4v4h-4zM6 17h4v4H6z"/>
    <path d="M10 5h4M8 7v10M16 7v10M10 19h4"/>
  </svg>
);
const IconSpecs = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.7">
    <path d="M7 3h10a2 2 0 0 1 2 2v9l-5 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/>
    <path d="M14 19v-4a2 2 0 0 1 2-2h4"/>
    <path d="M8 7h8M8 10h8M8 13h6"/>
  </svg>
);
const IconOptimize = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.7">
    <path d="M3 3v18h18"/>
    <path d="M7 15l3-3 3 3 4-6 3 4"/>
  </svg>
);
const IconStandards = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="1.7">
    <path d="M8 21h8M12 17v4"/>
    <path d="M8 4h8v3a4 4 0 0 1-8 0z"/>
    <path d="M5 5h3v2a3 3 0 0 1-3-3zM16 5h3a3 3 0 0 1-3 3z"/>
  </svg>
);

/* Переиспользуемая карточка */
function FeatureCard({ icon, title, lead, items, cta }) {
  return (
    <article className="relative flex flex-col rounded-2xl border border-gray-200 bg-white p-5 md:p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
      <div className="absolute inset-x-0 top-0 h-[3px] rounded-t-2xl bg-gradient-to-r from-indigo-500 to-sky-400" />
      
      <div className="mb-2 grid h-12 w-12 place-items-center rounded-xl bg-gradient-to-b from-indigo-100 to-sky-100 text-indigo-600">
        {icon}
      </div>
      
      <h3 className="text-lg font-semibold text-gray-900 leading-snug">{title}</h3>
      <p className="text-sm text-gray-500">{lead}</p>
      
      <ul className="mt-2 list-disc space-y-1 pl-4 text-sm text-gray-700 flex-1">
        {items.map((li, i) => <li key={i}>{li}</li>)}
      </ul>

      <a
        href={cta?.href || "#"}
        className="mt-4 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-indigo-500 to-sky-400 px-3.5 py-2.5 text-sm font-semibold text-white hover:brightness-110 text-center justify-center"
      >
        {cta?.label || "Подробнее"}
      </a>
    </article>
  );
}


/* Главный компонент секции */
export default function TopAdvantages() {
  const { t } = useTranslation();
  return (
    <div className="text-gray-900">
      {/* Хедер */}
      <header className="border-b border-gray-200 py-14 text-center">
        <div className="mx-auto max-w-screen-xl px-4">
          <h1 className="text-3xl font-bold gradient-text md:text-4xl">{t('Header17')}</h1>
          <p className="mx-auto mt-2 max-w-3xl text-sm text-gray-600 md:text-base">
            {t('$Subheader181')}
          </p>
        </div>
      </header>

      {/* Секция с карточками */}
      <section className="py-14">
        <div className="mx-auto max-w-screen-xl px-4">
          <header className="mb-9 text-center">
            <h2 className="text-2xl font-semibold text-gray-900 md:text-3xl">{t('$Header18')}</h2>
            <p className="text-gray-500">{t('$Subheader19')}</p>
          </header>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 min-[1101px]:grid-cols-4">
            <FeatureCard
              icon={<IconProcesses />}
              title={t('$ToolsGroup1')}
              lead={t('$ToolsGroupDesc1')}
              items={[
                t('$ToolsGroupList1')
              ]}
              cta={{ label: t('$ToolsGroupButton1'), href: "#" }}
            />
            <FeatureCard
              icon={<IconSpecs />}
              title={t('$ToolsGroup2')}
              lead={t('$ToolsGroupDesc2')}
              items={[
                t('$ToolsGroupList2')
              ]}
              cta={{ label: t('$ToolsGroupButton2'), href: "#" }}
            />
            <FeatureCard
              icon={<IconOptimize />}
              title={t('$ToolsGroup3')}
              lead={t('$ToolsGroupDesc3')}
              items={[
                t('$ToolsGroupList3')
              ]}
              cta={{ label: t('$ToolsGroupButton3'), href: "#" }}
            />
            <FeatureCard
              icon={<IconStandards />}
              title={t('$ToolsGroup4')}
              lead={t('$ToolsGroupDesc4')}
              items={[
                t('$ToolsGroupList4')
              ]}
              cta={{ label: t('$ToolsGroupButton4'), href: "#" }}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
